import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import moment from 'moment';
import Shared from 'screens/shared';
import CreateForm from 'screens/shared/load-balancers/create';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';
import NICs from './nics';

export default ({ history, match }) => {
  const { dcId, id } = match.params;
  const { [ACTIONS_TYPES.LOAD_BALANCER.GET]: loadbalancer = {} } = useSelector((e) => e);

  useEffect(() => {
    actions.loadbalancer.get({ dcId, id });
  }, [dcId, id]);

  const getLan = (e) => `LAN ${e?.properties?.lan}`;
  const propertiesRows = [
    ['IP', loadbalancer?.properties?.ip || 'No IP'],
    ['LANs', loadbalancer?.entities?.balancednics?.items?.map(getLan).join(', ') || 'No LAN has has been attached'],
    ['Is DHCP', loadbalancer?.properties?.dhcp ? 'Yes' : 'No'],
    [_t('Last Updated'), moment(loadbalancer?.metadata?.lastModifiedDate).fromNow()],
  ];

  const deleteHandler = () => {
    actions.loadbalancer.delete({ dcId, id });
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.LOAD_BALANCER}
      strapIcon="sitemap"
      strapTitle={loadbalancer?.properties?.name}
      editForm={<CreateForm item={{ id, ...loadbalancer?.properties }} {...{ dcId, id }} isEdit />}
      editAction={ACTIONS_TYPES.LOAD_BALANCER.UPDATE}
      onDelete={deleteHandler}
    >
      <Shared.widgets.Properties properties={propertiesRows} />
      <NICs nicsList={loadbalancer?.entities?.balancednics?.items || []} showTarget {...{ history, dcId, id }} />
    </Shared.widgets.Page>
  );
};
